import React, { useEffect } from "react";
import {
    MapPin,
    Phone,
    Mail,
    Facebook,
    Instagram,
    Linkedin,
    Twitter,
    Youtube
} from "react-feather";

import Logo from "../../assets/images/landingpage/logo.png"

const Footer = () => {



    return (
        <footer className="bg-light text-dark pt-5">
            <div className="container">

                {/* Top Info */}
                <div className="row mb-4" id="contactus">

                    <div className="col-md-4 mb-3" data-aos="zoom-in">
                        <div className="d-flex">
                            <MapPin className="me-3 lanp-primary-text fw-bold " size={35} style={{ width: '50px' }} />
                            <div>
                                <h6 className="fw-bold">Find Us</h6>
                                <p className="mb-0 small">
                                    Corporate Office: #18/9, AR Plaza, <br />
                                    3rd Floor, 100 Feet Ring Road, BTM <br />
                                    1st Stage,Bengaluru-560029
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 mb-3" data-aos="zoom-in">
                        <div className="d-flex">
                            <Phone className="me-3 lanp-primary-text fw-bold " size={35} style={{ width: '50px' }} />
                            <div>
                                <h6 className="fw-bold">For Inquires</h6>
                                <p className="mb-0 small">+91-91087 99731</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 mb-3" ddata-aos="zoom-in">
                        <div className="d-flex">
                            <Mail className="me-3 lanp-primary-text fw-bold " size={35} style={{ width: '50px' }} />
                            <div>
                                <h6 className="fw-bold">Mail Us</h6>
                                <p className="mb-0 small"> sales@azsmenterprises.com</p>
                            </div>
                        </div>
                    </div>

                </div>

                <hr />

                {/* Main Footer */}
                <div className="row mt-4">

                    {/* About */}
                    <div className="col-lg-4 mb-4" data-aos="zoom-in">
                        <a href="/home" className="mb-4">
                            <img src={Logo} alt="" className="50" />
                        </a>
                        <p className="small mt-3">
                            AZSM Enterprises is a technology partner specializing in developing innovative healthcare software and driving digital transformation for forward-thinking organizations.
                        </p>

                        <div className="d-flex gap-3 mt-3">
                            <a href="https://www.facebook.com/AzsmDevelopment/" className="lanp-primary-text"><Facebook size={18} /></a>
                            <a href="https://www.instagram.com/_azsmenterprises_/?hl=en" className="lanp-primary-text"><Instagram size={18} /></a>
                            <a href="https://in.linkedin.com/company/azsm-enterprises-it" className="lanp-primary-text"><Linkedin size={18} /></a>
                        </div>
                    </div>

                    {/* Links */}
                    <div className="col-lg-4 mb-4" data-aos="zoom-in">
                        <h6 className="fw-bold mb-3">Links</h6>
                        <ul className="list-unstyled small">
                            <li className="mb-2"><a href="/home" className="text-decoration-none text-dark">Home</a></li>
                            <li className="mb-2"><a href="#about" className="text-decoration-none text-dark">About Us</a></li>
                            <li className="mb-2"><a href="#azsmproducts" className="text-decoration-none text-dark">AZSM Products</a></li>
                            <li className="mb-2"><a href="#speciality" className="text-decoration-none text-dark">Speciality</a></li>
                            <li className="mb-2"><a href="#solutions" className="text-decoration-none text-dark">Solutions</a></li>
                            <li className="mb-2"><a href="#contactus" className="text-decoration-none text-dark">Contact Us</a></li>
                        </ul>
                    </div>

                    {/* Extra Links */}
                    <div className="col-lg-4 mb-4" data-aos="zoom-in">
                        <h6 className="fw-bold mb-3">Extra Links</h6>
                        <ul className="list-unstyled small">
                            <li className="mb-2"><a href="#" className="text-decoration-none text-dark">Why HMS?</a></li>
                            <li className="mb-2"><a href="#" className="text-decoration-none text-dark">HMS Benefits</a></li>
                            <li className="mb-2"><a href="/privacy-policy" className="text-decoration-none text-dark">Privacy Policy</a></li>
                            <li className="mb-2"><a href="/terms-conditions" className="text-decoration-none text-dark">Terms and Conditions</a></li>
                        </ul>
                    </div>

                </div>

                <hr />

                {/* Bottom */}
                <div className="text-center pb-3 small text-muted">
                    © {new Date().getFullYear()} © Copyright <span className="lanp-primary-text">AZSM Enterpprises</span>. All Rights Reserved
                </div>

            </div>
        </footer>
    );
};

export default Footer;